"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.string.link");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var Testimonial = function Testimonial(_ref) {
    var quote = _ref.quote, credit = _ref.credit, link = _ref.link, leftImage = _ref.leftImage, rightImage = _ref.rightImage;
    var imageUrlOne = leftImage ? _utils_1.imgixPath(leftImage) : undefined;
    var imageUrlTwo = rightImage ? _utils_1.imgixPath(rightImage) : undefined;
    return /*#__PURE__*/ react_1.default.createElement(StyledMargin, null, /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Content, {
        imageUrlOne: imageUrlOne,
        imageUrlTwo: imageUrlTwo
    }, /*#__PURE__*/ react_1.default.createElement(Copy, null, /*#__PURE__*/ react_1.default.createElement(Blockquote, {
        dangerouslySetInnerHTML: {
            __html: quote
        }
    }), /*#__PURE__*/ react_1.default.createElement(Credit, {
        dangerouslySetInnerHTML: {
            __html: credit
        }
    }))), link && /*#__PURE__*/ react_1.default.createElement(atoms_1.LinkMask, {
        to: link,
        target: "_blank",
        rel: "noopener"
    }, credit)));
}; // Styling
var StyledMargin = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "Quotation__StyledMargin",
    componentId: "sc-9neqkn-0"
})(["padding:32px 0;", "{padding:40px 0;}", "{padding:48px 0;}", "{padding:64px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Quotation__Wrapper",
    componentId: "sc-9neqkn-1"
})(["z-index:1;position:relative;display:flex;justify-content:center;max-width:100%;padding-bottom:32px;overflow-x:hidden;", "{padding-bottom:0;overflow:visible;}"], _utils_1.mediaQuery('tablet'));
var Content = styled_components_1.default.div.withConfig({
    displayName: "Quotation__Content",
    componentId: "sc-9neqkn-2"
})(["position:relative;display:flex;justify-content:center;background-color:", ";width:fit-content;&:before,&:after{z-index:2;position:absolute;background-repeat:no-repeat;background-size:contain;width:64px;height:100%;pointer-events:none;content:'';}", " ", " ", "{width:100%;&:before{bottom:auto;right:auto;top:-24px;left:72px;background-position:top left;}&:after{display:block;width:96px;}}", "{&:before{top:-32px;width:88px;left:122px;}&:after{bottom:-32px;width:112px;}}", "{&:before{width:120px;left:164px;}&:after{width:160px;}}"], _theme_1.palette.ivory, function (props) {
    return props.imageUrlOne && "\n    &:before {\n      bottom: -32px;\n      right: -16px;\n      background-image: url(" + props.imageUrlOne + "?fm=jp2&w=240), url(" + props.imageUrlOne + "?fm=webp&w=240);\n      background-position: bottom right;\n    }\n  ";
}, function (props) {
    return props.imageUrlTwo && "\n    &:after {\n      display: none;\n      bottom: -24px;\n      right: 0;\n      background-image: url(" + props.imageUrlTwo + "?fm=jp2&w=320), url(" + props.imageUrlTwo + "?fm=webp&w=320, );\n      background-position: bottom right;\n    }\n  ";
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Copy = styled_components_1.default.div.withConfig({
    displayName: "Quotation__Copy",
    componentId: "sc-9neqkn-3"
})(["position:relative;max-width:380px;margin:0 auto;", "{max-width:480px;padding-left:0;padding-right:0;}", "{max-width:590px;}", "{max-width:680px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Blockquote = styled_components_1.default.div.withConfig({
    displayName: "Quotation__Blockquote",
    componentId: "sc-9neqkn-4"
})(["position:relative;padding:0 24px 0 48px;", " color:", ";&::after{z-index:1;position:absolute;top:0;left:24px;background-color:", ";width:1px;height:100%;content:'';}", "{padding:0 24px 0 48px;&::after{left:16px;}}"], _theme_1.type.blockquote, _theme_1.palette.ink, _utils_1.rgba(_theme_1.palette.ink, 0.32), _utils_1.mediaQuery('tablet'));
var Credit = styled_components_1.default.footer.withConfig({
    displayName: "Quotation__Credit",
    componentId: "sc-9neqkn-5"
})(["padding:24px 64px 0 24px;", " color:", ";&::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:-.4em;}&::after{margin-bottom:-.35em;}", "{padding:32px 24px 0 48px;}", "{padding-top:40px;}"], _theme_1.type.h4, _theme_1.palette.rifle, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop')); // Types
exports.default = Testimonial;
